<script>
import { h, ref, computed } from 'vue';

export default {
    inheritAttrs: false,
    setup(props, { attrs, slots }) {
        const inProgress = ref(null);

        const content = computed(() => {
            if (inProgress.value && slots.inprogress) {
                return slots.inprogress();
            }
            return slots.default();
        });

        const onClick = async (event) => {
            const cb = attrs.onClick;
            if (cb) {
                inProgress.value = true;
                try {
                    await cb(event);
                } finally {
                    inProgress.value = null;
                }
            }
        };

        return () => h(
            'button',
            {
                ...attrs,
                disabled: attrs.disabled === true || inProgress.value,
                onClick,
            },
            content.value
        );
    },
};
</script>
